import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: ReactNode;
  hint?: string;
}

export function Input({ label, icon, hint, className, ...rest }: InputProps) {
  return (
    <label className="block space-y-2">
      {label && <span className="text-xs font-bold uppercase tracking-wider text-[#666666]">{label}</span>}
      <span className="relative block">
        {icon && <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#999999]">{icon}</span>}
        <input
          className={cn(
            'w-full py-3 bg-white border border-[#E5E5E5] rounded-2xl focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-[#1A1A1A] transition-all',
            icon ? 'pl-12 pr-4' : 'px-4',
            className,
          )}
          {...rest}
        />
      </span>
      {hint && <span className="text-xs text-[#999999]">{hint}</span>}
    </label>
  );
}
